// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import heroNavScroll from "./heroNavScroll";
import infiniteScroll from "./infiniteScroll";
import menuOpen from "./menuOpen";
import contactForm from "./contactForm";

// Call the menu and infinite scroll functions
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

function init() {
    menuOpen();
    infiniteScroll();
    heroNavScroll();
    contactForm();
}